import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartnerService } from '../../../services/partner.service';


@Component({
  selector: 'app-show-mapper-modal',
  templateUrl: './show-mapper-modal.component.html',
  styleUrls: ['./show-mapper-modal.component.scss']
})
export class ShowMapperModalComponent implements OnInit {

  // title: any;
  
  importedProShow: any;
  selectedProShow: any;
  shows: any;
  filteredShows: any;
  originalTitle: any;
  alternateTitle: any;
  searchText: '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private partnerService: PartnerService, 
    private dialogRef: MatDialogRef<ShowMapperModalComponent>,
  ) { }

  ngOnInit() {
    if (this.data.importedProShow) {
      this.importedProShow = this.data.importedProShow;
    }
    if (this.data.shows) {
      this.shows = this.data.shows;
      this.filteredShows = this.shows;
    }
  }


  //Filter shows on the 'map show' modal
  onShowSearchChange(): void {
    this.filteredShows = this.shows.filter(show =>
      show.title.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onOptionSelected(event: any): void {
    this.selectedProShow = event.option.value; // Populate the selected value
  }



  close(): void {
    this.dialogRef.close();
    this.partnerService.notifyModalClosed(); // Notify modal closed  
  }

  cancel(): void {
    this.dialogRef.close();
  }

  mapShowToShow() {
    this.originalTitle = this.selectedProShow;
    this.alternateTitle = this.importedProShow.showName;
    this.partnerService.createTitleMapping(this.originalTitle, this.alternateTitle).subscribe( (res: any) => {
      console.log(res);
      this.close();
    });
  }

}
